import { sequence } from '@angular/animations';
import { Component, ElementRef, Input, OnInit } from '@angular/core';
import {
  CEM_TOP_JOB_TYPE_INDETERMINATE,
  CEM_TOP_JOB_TYPE_NOT_APPLY,
  CEM_TOP_JOB_TYPE_YES,
  HANDOVER_TYPE_HO1_ID,
  HANDOVER_TYPE_HO2_ID,
  HANDOVER_TYPE_HO4_ID,
  HANDOVER_TYPE_HO5_ID,
  HANDOVER_TYPE_HOG_ID,
  OPERATIONAL_AREA_DRILLING_ID,
  OPERATIONAL_AREA_COMPLETION_ID,
  HANDOVER_STATUS_ACCEPTED,
  HANDOVER_TYPE_HOAC_ID,
  HANDOVER_TYPE_HOEC_ID,
} from '../../handover-constants';
import {
  Cementing,
  CementingAttachmentType,
  CementingFileAttachment,
  PartialCementingFileAttachment,
  Plug,
  Squeeze,
} from 'src/app/interfaces/cementing';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { NotificationService } from 'src/app/services/notification.service';
import { PendingChanges } from '../shared/pending-changes.class';
import { Handover } from 'src/app/interfaces/handover';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-detail-cementing',
  templateUrl: './handover-detail-cementing.component.html',
  styleUrls: ['./handover-detail-cementing.component.scss'],
  standalone: false,
})
export class HandoverDetailCementingComponent
  extends PendingChanges
  implements OnInit
{
  @Input() handover: Handover | undefined;
  @Input() readOnlyContent!: boolean;

  cementings: Cementing[] = [];
  squeezes: Squeeze[] = [];
  plugs: Plug[] = [];
  showFooterNoDataOrign = false;
  dhoApiUrl = `${environment.urlBackend}/dhoapi`;

  displayedColumnsSqueeze = [
    'assemblySize',
    'stageNo',
    'squeezeSetMd',
    'squeezeObjective',
    'metodoEvaluacion',
    'prodSlurryQuality',
    'actions',
  ];
  displayedColumnsPlugs = [
    'assemblySize',
    'stageNo',
    'estTop',
    'estBottom',
    'stageType',
    'plugObjective',
    'metodoEvaluacion',
    'tocMd',
    'prodSlurryQuality',
    'actions',
  ];
  displayedColumns = [
    'assemblySize',
    'stageNo',
    'isPlugBumped',
    'mdTopStage',
    'tocMd',
    'pressureHeld',
    'finalPressure',
    'makeTopJob',
    'actions',
  ];
  isLoading = false;
  hideFooter = true;
  hideFooterSqueezes = true;
  hideFooterPlugs = true;

  originalCementings: Cementing[] = [];
  originalSqueezes: Squeeze[] = [];
  originalPlugs: Plug[] = [];
  isDisabled: boolean[] = [];
  isDisabledSqueezes: boolean[] = [];
  isDisabledPlugs: boolean[] = [];
  tooltipDescription = '';

  fileLimit = 2;
  buttonFile = false;
  uploadfile = false;
  displayCementingAttachment = false;
  cementingFileAttachments: CementingFileAttachment[] = [];
  originalCementingFileAttachments: CementingFileAttachment[] = [];
  chosenCementingAttachment: PartialCementingFileAttachment =
    {} as PartialCementingFileAttachment;
  chosenCementingAttachmentType: CementingAttachmentType =
    {} as CementingAttachmentType;
  cementingAttachmentTypes: CementingAttachmentType[] = [];
  attachmentSubmissionIsEnabled = false;
  attachmentTypeSubmissionIsEnabled = false;
  attachmentDescriptionSubmissionIsEnabled = false;
  chosenCementingAttachmentTypeDescription = '';
  attachmentTypeUpdateIsEnabled: boolean[] = [];

  constructor(
    public handoverService: HandoverService,
    private notificationService: NotificationService,
    public dialogService: DialogService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.handoverService) {
      this.setCementingDataSource();
      this.setSqueezesDataSource();
      this.setPlugsDataSource();
      this.showFooterNoDataOrign =
        this.handover!.handoverStatusId != HANDOVER_STATUS_ACCEPTED;
      if (
        this.handover?.handoverTypeId == HANDOVER_TYPE_HO1_ID ||
        this.handover?.handoverTypeId == HANDOVER_TYPE_HOEC_ID ||
        this.handover?.handoverTypeId == HANDOVER_TYPE_HOAC_ID
      ) {
        this.displayCementingAttachment = true;
        this.getCementingAttachmentAndAttachmentTypes();
      }
    }
  }

  setCementingDataSource(): void {
    this.isLoading = true;
    this.handoverService
      .getCementings(
        this.handover!.handoverId,
        this.handover!.wellId,
        this.handover!.handoverStatusId,
        this.handover!.handoverTypeId
      )
      .subscribe((cementings: Cementing[]) => {
        this.cementings = cementings;
        this.hideFooter = cementings.length > 0;
        this.setOriginalCementingsValues(cementings);
        this.isLoading = false;
      });
  }

  setOriginalCementingsValues(cementings: Cementing[]): void {
    cementings.map((val) => {
      if (val.comments == null) val.comments = '';
      this.originalCementings.push(Object.assign({}, val));
      this.isDisabled.push(true);
    });
  }

  setSqueezesDataSource(): void {
    this.handoverService
      .getCementingsSqueezes(
        this.handover!.handoverId,
        this.handover!.wellId,
        this.handover!.handoverStatusId,
        this.handover!.handoverTypeId
      )
      .subscribe((squeezes: Squeeze[]) => {
        this.squeezes = squeezes;
        this.hideFooterSqueezes = squeezes.length > 0;
        this.setOriginalSqueezesValues(squeezes);
      });
  }

  setOriginalSqueezesValues(squeezes: Squeeze[]): void {
    squeezes.map((val) => {
      if (val.comments == null) val.comments = '';
      this.originalSqueezes.push(Object.assign({}, val));
      this.isDisabledSqueezes.push(true);
    });
  }

  setPlugsDataSource(): void {
    this.handoverService
      .getCementingsPlugs(
        this.handover!.handoverId,
        this.handover!.wellId,
        this.handover!.handoverStatusId,
        this.handover!.handoverTypeId
      )
      .subscribe((plugs: Plug[]) => {
        this.plugs = plugs;
        this.hideFooterPlugs = plugs.length > 0;
        this.setOriginalPlugsValues(plugs);
      });
  }

  setOriginalPlugsValues(plugs: Plug[]): void {
    plugs.map((val) => {
      if (val.comments == null) val.comments = '';
      this.originalPlugs.push(Object.assign({}, val));
      this.isDisabledPlugs.push(true);
    });
  }

  saveCementing(cementing: Cementing, index: number): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Cementación',
      '¿Desea guardar los cambios realizados en Primaria?'
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        cementing.handoverId = this.handover!.handoverId;
        const cementings: Cementing[] = [];
        cementings.push(cementing);

        this.handoverService
          .saveCementings(cementings)
          .subscribe((savedCementings: Cementing[]) => {
            if (savedCementings) {
              this.notificationService.notify(
                'Los cambios de Primaria se han guardado con éxito.',
                true
              );
              this.isDisabled[index] = true;
              this.originalCementings[index].makeTopJob = cementing.makeTopJob;
              this.originalCementings[index].comments = cementing.comments;
              this.reportPendingChanges();
            } else {
              this.notificationService.notify(
                'Ocurrió un error al grabar los cambios de Primaria.',
                false
              );
            }
          });
      }
    });
  }

  openComments(
    comments: string | undefined,
    index: number,
    event: any,
    readOnly: boolean
  ): void {
    const target = new ElementRef(event.currentTarget);
    this.dialogService
      .openCommentDialog('Comentarios', comments, target, -200, -450, readOnly)
      .afterClosed()
      .subscribe((comments: string) => {
        this.cementings[index].comments = comments;
        this.enableSaveButton(
          index,
          comments,
          this.cementings[index].makeTopJob
        );
      });
  }

  enableSaveButton(
    index: number,
    comments: string | undefined,
    makeTopJob: string
  ): void {
    const enable =
      makeTopJob != this.originalCementings[index].makeTopJob ||
      comments != this.originalCementings[index].comments;
    this.isDisabled[index] = !enable;
    this.reportPendingChanges();
  }

  openCommentsSqueezes(
    comments: string | undefined,
    index: number,
    event: any,
    readOnly: boolean
  ): void {
    const target = new ElementRef(event.currentTarget);
    this.dialogService
      .openCommentDialog('Comentarios', comments, target, -200, -450, readOnly)
      .afterClosed()
      .subscribe((comments: string) => {
        this.squeezes[index].comments = comments;
        this.enableSaveButtonSqueezes(index, comments);
      });
  }

  enableSaveButtonSqueezes(index: number, comments: string | undefined): void {
    const enable = comments != this.originalSqueezes[index].comments;
    this.isDisabledSqueezes[index] = !enable;
    this.reportPendingChanges();
  }

  openCommentsPlugs(
    comments: string | undefined,
    index: number,
    event: any,
    readOnly: boolean
  ): void {
    const target = new ElementRef(event.currentTarget);
    this.dialogService
      .openCommentDialog('Comentarios', comments, target, -200, -450, readOnly)
      .afterClosed()
      .subscribe((comments: string) => {
        this.plugs[index].comments = comments;
        this.enableSaveButtonPlugs(index, comments);
      });
  }

  enableSaveButtonPlugs(index: number, comments: string | undefined): void {
    const enable = comments != this.originalSqueezes[index].comments;
    this.isDisabledPlugs[index] = !enable;
    this.reportPendingChanges();
  }

  saveCementingSqueeze(squeeze: Squeeze, index: number): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Squeezes',
      '¿Desea guardar los cambios realizados en Squeeze?'
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        squeeze.handoverId = this.handover!.handoverId;
        const squeezes: Squeeze[] = [];
        squeezes.push(squeeze);

        this.handoverService
          .saveCementingsSqueeze(squeezes)
          .subscribe((savedSqueezes: Squeeze[]) => {
            if (savedSqueezes) {
              this.notificationService.notify(
                'Los cambios de Squeeze se han guardado con éxito.',
                true
              );
              this.isDisabledSqueezes[index] = true;
              this.originalSqueezes[index].comments = squeeze.comments;
              this.reportPendingChanges();
            } else {
              this.notificationService.notify(
                'Ocurrió un error al grabar los cambios de Squeeze.',
                false
              );
            }
          });
      }
    });
  }

  saveCementingPlug(plug: Plug, index: number): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Cementación',
      '¿Desea guardar los cambios realizados en Tapones?'
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        plug.handoverId = this.handover!.handoverId;
        const plugs: Plug[] = [];
        plugs.push(plug);

        this.handoverService
          .saveCementingsPlug(plugs)
          .subscribe((savedPlugs: Plug[]) => {
            if (savedPlugs) {
              this.notificationService.notify(
                'Los cambios de Tapón se han guardado con éxito.',
                true
              );
              this.isDisabledPlugs[index] = true;
              this.originalPlugs[index].comments = plug.comments;
              this.reportPendingChanges();
            } else {
              this.notificationService.notify(
                'Ocurrió un error al grabar los cambios de Tapones.',
                false
              );
            }
          });
      }
    });
  }

  seeTopJobOptions(topJobDescription: string): boolean {
    if (
      topJobDescription == CEM_TOP_JOB_TYPE_YES ||
      (topJobDescription == CEM_TOP_JOB_TYPE_INDETERMINATE &&
        (this.handover!.handoverTypeId == HANDOVER_TYPE_HO1_ID ||
          this.handover!.handoverTypeId == HANDOVER_TYPE_HOG_ID ||
          (this.handover!.handoverTypeId == HANDOVER_TYPE_HO5_ID &&
            this.handover!.fromAreaId == OPERATIONAL_AREA_DRILLING_ID)))
    ) {
      return true;
    } else {
      return false;
    }
  }

  seeTopJobTextDescription(topJobDescription: string): boolean {
    if (
      topJobDescription == CEM_TOP_JOB_TYPE_NOT_APPLY ||
      (topJobDescription == CEM_TOP_JOB_TYPE_INDETERMINATE &&
        (this.handover!.handoverTypeId == HANDOVER_TYPE_HO2_ID ||
          this.handover!.handoverTypeId == HANDOVER_TYPE_HO4_ID ||
          (this.handover!.handoverTypeId == HANDOVER_TYPE_HO5_ID &&
            this.handover!.fromAreaId == OPERATIONAL_AREA_COMPLETION_ID)))
    ) {
      if (topJobDescription == CEM_TOP_JOB_TYPE_NOT_APPLY) {
        this.tooltipDescription = 'NO es CASING SURFACE o CONDUCTOR.';
      } else {
        this.tooltipDescription =
          'No se confirmaron los criterios que indican que se realizó TopJob. Puede que NO se haya realizado';
      }
      return true;
    } else {
      this.tooltipDescription = '';
      return false;
    }
  }

  seeMandatorySeleccionText(topJobDescription: string): boolean {
    if (
      topJobDescription == CEM_TOP_JOB_TYPE_INDETERMINATE &&
      (this.handover!.handoverTypeId == HANDOVER_TYPE_HO1_ID ||
        this.handover!.handoverTypeId == HANDOVER_TYPE_HOG_ID ||
        (this.handover!.handoverTypeId == HANDOVER_TYPE_HO5_ID &&
          this.handover!.fromAreaId == OPERATIONAL_AREA_DRILLING_ID))
    ) {
      return true;
    } else {
      return false;
    }
  }

  reportPendingChanges(): void {
    let thereAreChanges = false;
    for (let index = 0; index < this.cementings.length; index++) {
      thereAreChanges =
        thereAreChanges ||
        this.cementings[index].makeTopJob !=
          this.originalCementings[index].makeTopJob ||
        this.cementings[index].comments !=
          this.originalCementings[index].comments;
    }
    for (let index = 0; index < this.squeezes.length; index++) {
      thereAreChanges =
        thereAreChanges ||
        this.squeezes[index].comments != this.originalSqueezes[index].comments;
    }
    for (let index = 0; index < this.plugs.length; index++) {
      thereAreChanges =
        thereAreChanges ||
        this.plugs[index].comments != this.originalPlugs[index].comments;
    }

    if (this.attachmentSubmissionIsEnabled) thereAreChanges = true;
    if (this.attachmentTypeSubmissionIsEnabled) thereAreChanges = true;
    if (this.attachmentDescriptionSubmissionIsEnabled) thereAreChanges = true;
    if (this.attachmentTypeUpdateIsEnabled.some((valor) => valor === true))
      thereAreChanges = true;
    this.emitPendingChanges(thereAreChanges);
  }

  getCementingAttachmentAndAttachmentTypes(): void {
    this.isLoading = true;
    this.handoverService.getCementingAttachmentTypes().subscribe(
      (values: CementingAttachmentType[]) => {
        this.cementingAttachmentTypes = values;
        if (this.handover?.handoverId) {
          this.handoverService
            .getCementingAttachment(this.handover?.handoverId)
            .subscribe((values: CementingFileAttachment[]) => {
              this.cementingFileAttachments = JSON.parse(
                JSON.stringify(values)
              );
              this.originalCementingFileAttachments = JSON.parse(
                JSON.stringify(values)
              );
              this.filterAttachmentTypes();
              this.isLoading = false;
            });
        }
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  getCementingAttachmentUpdate(): void {
    this.isLoading = true;
    if (this.handover?.handoverId) {
      this.handoverService
        .getCementingAttachment(this.handover?.handoverId)
        .subscribe((values: CementingFileAttachment[]) => {
          this.cementingFileAttachments = JSON.parse(JSON.stringify(values));
          this.originalCementingFileAttachments = JSON.parse(
            JSON.stringify(values)
          );
          this.isLoading = false;
        });
    }
  }

  filterAttachmentTypes(): void {
    this.cementingFileAttachments.forEach((cementingAttachment) => {
      this.cementingAttachmentTypes = this.cementingAttachmentTypes.filter(
        (element) => {
          return (
            element.cementingAttachmentTypeId !=
            cementingAttachment.cementingAttachmentType
              .cementingAttachmentTypeId
          );
        }
      );
    });
  }

  onFileChosenSelected(event: any): void {
    const file: File = event.target.files[0];
    this.chosenCementingAttachment.fileToUpload = file;
    if (this.chosenCementingAttachment.fileToUpload) {
      this.attachmentSubmissionIsEnabled = true;
      this.reportPendingChanges();
    }
  }

  onFileChosenDeleted(): void {
    this.chosenCementingAttachment.fileToUpload = undefined;
    this.attachmentSubmissionIsEnabled = false;
    this.reportPendingChanges();
  }

  onSelectAttachmentType(): void {
    if (this.chosenCementingAttachment.cementingAttachmentType) {
      this.attachmentTypeSubmissionIsEnabled = true;
    } else {
      this.attachmentTypeSubmissionIsEnabled = false;
    }
    this.reportPendingChanges();
  }

  deniedDownload(event: any): void {
    event.preventDefault();
    this.notificationService.notify(
      'Para descargar el archivo, previamente debe seleccionar LISTO',
      false
    );
  }

  enableDescriptionAttachmentSubmission(): void {
    if (this.chosenCementingAttachment?.cementingAttachmentDescription) {
      this.attachmentDescriptionSubmissionIsEnabled =
        this.chosenCementingAttachment?.cementingAttachmentDescription.trim()
          .length >= 1;
    } else {
      this.attachmentDescriptionSubmissionIsEnabled = false;
    }
    this.reportPendingChanges();
  }

  isDisabledSubmit(): boolean {
    if (
      this.chosenCementingAttachment.cementingAttachmentType
        ?.cementingAttachmenTypeWithDescription
    ) {
      if (
        !this.attachmentSubmissionIsEnabled ||
        !this.attachmentTypeSubmissionIsEnabled ||
        !this.attachmentDescriptionSubmissionIsEnabled
      )
        return true;
    } else {
      if (
        !this.attachmentSubmissionIsEnabled ||
        !this.attachmentTypeSubmissionIsEnabled
      )
        return true;
    }
    return false;
  }

  submitAttachment(): void {
    if (!this.handover?.handoverId) {
      return;
    }
    this.isLoading = true;
    const formData = new FormData();
    if (this.chosenCementingAttachment.fileToUpload) {
      formData.append('file', this.chosenCementingAttachment.fileToUpload);
    }
    if (this.chosenCementingAttachment?.cementingAttachmentType) {
      formData.append(
        'cementingAttachmentType',
        JSON.stringify(this.chosenCementingAttachment?.cementingAttachmentType)
      );
    }
    if (this.chosenCementingAttachment?.cementingAttachmentDescription) {
      formData.append(
        'cementingAttachmentDescription',
        this.chosenCementingAttachment.cementingAttachmentDescription
      );
    }
    this.handoverService
      .saveCementingAttachment(this.handover?.handoverId, formData)
      .subscribe((savedProblem: CementingFileAttachment) => {
        this.isLoading = false;
        if (savedProblem) {
          this.clearConditions();
          this.getCementingAttachmentAndAttachmentTypes();
          this.reportPendingChanges();
          this.notificationService.notify(
            'Reporte de Cementación agregado satisfactoriamente',
            true
          );
        }
      });
  }

  updateAttachment(cementingAttachment: CementingFileAttachment): void {
    if (!this.handover?.handoverId) {
      return;
    }
    this.isLoading = true;
    const formData = new FormData();
    if (cementingAttachment.fileToUpload) {
      formData.append('file', cementingAttachment.fileToUpload);
    }
    if (cementingAttachment?.cementingAttachmentType) {
      formData.append(
        'cementingAttachmentType',
        JSON.stringify(cementingAttachment?.cementingAttachmentType)
      );
    }
    if (cementingAttachment?.cementingAttachmentDescription) {
      formData.append(
        'cementingAttachmentDescription',
        cementingAttachment.cementingAttachmentDescription
      );
    }
    if (cementingAttachment?.cementingAttachmentDescription) {
      formData.append('fileId', JSON.stringify(cementingAttachment.fileId));
    }
    this.handoverService
      .saveCementingAttachment(this.handover?.handoverId, formData)
      .subscribe((savedAttach: CementingFileAttachment) => {
        this.isLoading = false;
        if (savedAttach) {
          this.attachmentTypeUpdateIsEnabled.fill(false);
          this.getCementingAttachmentUpdate();
          this.reportPendingChanges();
          this.notificationService.notify(
            'Reporte de Cementación actualizado satisfactoriamente',
            true
          );
        }
      });
  }

  deleteCementingAttachment(fileId: number): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Reportes de Cementación',
      `¿Está seguro de que desea eliminar este reporte?`
    );
    dialogRef.afterClosed().subscribe((confirmRemove) => {
      if (confirmRemove && this.handover?.handoverId) {
        this.isLoading = true;
        this.handoverService
          .deleteCementingAttachment(this.handover?.handoverId, fileId)
          .subscribe((deletedAttach) => {
            this.isLoading = false;
            if (deletedAttach) {
              this.clearConditions();
              this.getCementingAttachmentAndAttachmentTypes();
              this.reportPendingChanges();
              this.notificationService.notify(
                'Reporte de Cementación eliminado satisfactoriamente',
                true
              );
            }
          });
      }
    });
  }

  clearConditions(): void {
    this.chosenCementingAttachment = {};
    this.attachmentTypeSubmissionIsEnabled = false;
    this.attachmentSubmissionIsEnabled = false;
    this.attachmentDescriptionSubmissionIsEnabled = false;
    this.attachmentTypeUpdateIsEnabled.fill(false);
  }

  descriptionAttachmentUpdate(
    index: number,
    cementingAttachmentDescription: string
  ): void {
    if (
      this.originalCementingFileAttachments[index]
        .cementingAttachmentDescription == cementingAttachmentDescription
    ) {
      this.attachmentTypeUpdateIsEnabled[index] = false;
    } else {
      this.attachmentTypeUpdateIsEnabled[index] =
        cementingAttachmentDescription.trim().length >= 1;
    }
    this.reportPendingChanges();
  }
}
